import yup from 'yup'

const passwordRex = new RegExp('^(?=.*\\d)(?=.*[!@#$%^&*\\.\\,\\:])(?=.*[a-z])(?=.*[A-Z]).{8,32}$');

yup.addMethod(yup.mixed, 'sameAs', function (ref, message) {
  return this.test('sameAs', message, function (value) {
      const other = this.resolve(ref);
      console.log('other : ', other);
      console.log('value : ', value);
      return !other || !value || value === other;
  });
});

const schema = yup
  .object()
  .shape({
    name                 : yup.string()
                              .min(3, 'Minimum 3 characters')
                              .max(64, 'Too long (max 64 characters)')
                              .required('Name is required'),
    email                : yup.string()
                              .email('Please enter a correct email')
                              .required('Email is required'),
    password             : yup.string()
                              .matches(passwordRex, 'Invalid format')
  })

export default schema



// WEBPACK FOOTER //
// ./src/forms/Manager/schema.js